import PropTypes from 'prop-types'
import { Alert, Box, Button, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import useStyles from './styles'

const Download = ({ downloadUrl }) => {
  const t = useTranslations()
  const classes = useStyles()

  return (
    <Box className={classes.downloadAppWrapper}>
      <Alert severity="warning" className={classes.alert}>
        {t('print-settings:app-jspm-no-installed')}
      </Alert>

      <Typography variant="body1" className={classes.downloadAppExplanation}>
        {t('print-settings:app-jspm-explanation')}
      </Typography>

      <Button component="a" href={downloadUrl}>
        {t('print-settings:install-jsprintmanager')}
      </Button>
    </Box>
  )
}

Download.propTypes = {
  downloadUrl: PropTypes.string,
}

export default Download
